import { Component, inject } from '@angular/core';
import { BannerAppComponent } from '../../../components/banner-app/banner-app.component';
import { FooterAppComponent } from '../../../components/footer-app/footer-app.component';
import { getFromStorage, saveToStorage } from '../../../helpers/storageUtils';
import { Router } from '@angular/router';
import { DATOS_RESTANTES } from '../../../routes.constans';

@Component({
  selector: 'sura-check-the-information',
  standalone: true,
  imports: [BannerAppComponent, FooterAppComponent],
  templateUrl: './check-the-information.component.html',
  styleUrl: './check-the-information.component.scss',
})

export class CheckTheInformationComponent {

  private router = inject(Router);

  attemps = getFromStorage<number>('sarlaftAttemps', 'session') || 0;

  retry() {
    saveToStorage('sarlaftAttemps', this.attemps + 1, 'session');
    this.router.navigate([DATOS_RESTANTES]);
  }
}
